import {getUserRecentMenu} from "@/layouts/layoutFrame/hooks/useCollectMenus";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import {useRouter} from "vue-router";
import {useI18n} from "@/hooks/web/useI18n";
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";

export function useUserRecentMenu(){

  const menuList:any=ref([]);

  /**
   * 加载最近使用的菜单集合
   */
  const loadingUserMenuList=async function (){
    const res =await getUserRecentMenu();
    if(res&&Array.isArray(res)){
      if(res&&res.length>20){
        menuList.value=res.splice(0,20);
      }else{
        menuList.value=res;
      }
    }
  }


  const menuStore = useMenuStore();
  const {
    activeMenuId
  }:any = storeToRefs(menuStore)

  const router = useRouter();
  const { t } = useI18n();
  const {
    menuClick
  }=useMenuHooks(router,t);

  /**
   * 设置激活的菜单
   * @param item
   */
  const selActiveOneMenu=function (item){
    activeMenuId.value=item.id;
    menuClick({key:item.path, menuId:item.id},unref(menuList));
  }


  onMounted(()=>{
    loadingUserMenuList();
  })



  return {
    activeMenuId,
    selActiveOneMenu,
    menuList
  }
}
